export default __webpack_public_path__ + "static/media/airdome-alive.26b983aa.svg";